<template>
<!--内容列表-->
  <div id="contenList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input @keyup.enter="getList(1)" class="allInput" placeholder="标题" type="text" v-model="postData.title">
          </p>
          <p>
            <input @keyup.enter="getList(1)" class="allInput" placeholder="标签" type="text" v-model="postData.tags">
          </p>
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="searchCate" :needReturn="'id'" :placeholder="'请选择内容分类'" :matchValue="'name'" :showValue="'{{productName}} | {{name}}'" v-model="postData.categoryId">
              </allSelect>
            </abbr>
          </p>
          <button @click="getList(1)" class="redButton">搜索</button>
        </div>
        <div style="width: auto">
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th>序号</th>
            <th>文章ID</th>
            <th>标题</th>
            <th>标签</th>
            <th>修改时间</th>
            <th class="t_c">修改人</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myList">
            <td width="10%">{{totalCount - ((index + 1) + (10 * (postData.PageIndex - 1))) + 1}}</td>
            <td width="10%">{{item.articleID}}</td>
            <td width="16%" class="NoWrap" style="max-width: 250px" :title="item.title">{{item.title}}</td>
            <td width="25%" :title="item.tags" class="NoWrap" style="max-width: 250px">{{item.tags}}</td>
            <td width="19%">{{item.creationTime ? $commonJs.returnNewDate(item.creationTime) : ''}}</td>
            <td width="10%" :title="item.createName" style="max-width: 100px" class="t_c NoWrap">{{item.createName}}</td>
            <td width="10%">{{getStatusDescription(item.status)}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    <contentPreview :forType="'contentReadAll'" :doctorOpenId="doctorOpenId" :contentId="previewContentId" v-model="coverShow"></contentPreview>
  </div>
</template>

<script>
import contentPreview from '../../myComponents/contentPreview'
export default {
  name: 'contenList',
  data () {
    return {
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      previewContentId: 0,
      doctorOpenId: '',
      addnewContentType: '',
      onSearch: false,
      coverShow: false,
      newModel: false,
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        title: '',
        status: 2,
        ContentTypeIds: '',
        categoryId: '',
        startdate: '',
        tags: '',
        enddate: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      allcontent: JSON.parse(window.sessionStorage.getItem('allContentType')),
      allcontent2: JSON.parse(window.localStorage.getItem('canEditList')) || [{id: 1, typeName: '测试类别'}],
      searchCate: [{
        id: '',
        name: '全部',
        productName: '全部'
      }]
    }
  },
  created () {
    console.log(this.userInfo, 'userInfo')
    this.searchCate = this.searchCate.concat(this.allcontent2)
    this.getList(1)
  },
  methods: {
    getStatusDescription(Status) {
          return Status === 1? '编辑保存' :
                 Status === 2? '退回' :
                 Status === 3? '删除' :
                 Status === 4? '修改创建人' :
                 '';
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      if (data.startdate === '') {
        delete data['startdate']
      }
      if (data.enddate === '') {
        delete data['enddate']
      }
      let url = this.$commonJs.returnQuery('/api/Article/GetArticleOperateLog', data)
      this.$axiox.getList(url).then(msg => {
        console.log(msg)
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
      console.log(this.postData)
    },
    editList (item) {
      this.$router.push({
        name: 'editContList',
        query: {
          id: item.id,
          fromType: 'draft',
          selectContentType: 0,
          selectContentName: item.contentType
        }
      })
    }
  },
  components: {
    'contentPreview': contentPreview
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/contenOperateLog.vue